import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';
/** Tells a giveaway host that a winner has claimed their prize. */
export default class GiveawayClaimedNotification extends Notification {
  icon() {
    return 'fas fa-box-open';
  }
  href() {
    const data = this.attrs.notification.content() || {};
    return data.slug ? app.route('giveaways.show', {
      slug: data.slug
    }) : app.route('giveaways.index');
  }
  content() {
    return app.translator.trans('ernestdefoe-giveaways.forum.notification.claimed_content');
  }
  excerpt() {
    const data = this.attrs.notification.content() || {};
    return data.prize || data.title;
  }
}
flarum.reg.add('ernestdefoe-giveaways', 'forum/components/GiveawayClaimedNotification', GiveawayClaimedNotification);